import React from 'react';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMReservationHeaderView from 'components/dashboard/shared/SMReservationHeaderView';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';

class SMUReputationView extends SMDashboardBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      score: 0,
      description: "",
      errors: [],
      room_features: [],
      service_description: "",
      net_promoter_score: null
    };
  }

  componentWillMount() {
    const reputation = this.props.reputation;
    const errors = this.props.errors;
    
    if (reputation) {
      const room_features = reputation.room_features.map((room_feature)=>{
        if (typeof room_feature === 'string') {
          return room_feature;
        } else {
          return room_feature.name;
        }
      });
     
      this.setState({
        id: reputation.id,
        score: reputation.score,
        description: reputation.description,
        errors: errors,
        room_features: room_features,
        service_description: reputation.service_description,
        net_promoter_score: reputation.net_promoter_score
      });
    }
  }

  componentDidMount() {
    this.renderStars(this.state.score);
    this.subscribeRateEvent();
    this.applyResponsive();
  }
  
  trackPageEvent() {
    SMTrackHelper.pageEvent('ud submit reputation');
  }

  didChangeServiceDescriptionValue(e){
    this.setState({
      service_description: e.currentTarget.value,
    });
  }

  renderServiceDescriptionForm() {
    return(
      <div className="form-box mb30">
        <textarea value={this.state.service_description} name="service_description" onChange={this.didChangeServiceDescriptionValue.bind(this)} className="form-textarea post-review-form" placeholder="使いやすかったところ、不便だったところなどなんでも自由にお聞かせください！"></textarea>
        {this.renderReputationError("service_description")}
      </div>
    );
  }

  toggleChangeNPSValue(e) {
    this.setState({
      net_promoter_score: e.currentTarget.value
    });
  }

  renderNPSError(field) {
    let errorText = SMFormatHelper.errorText('NetPromoterScore', field, this.state.errors);
 
    if (field == 'score') {
      field = 'net_promoter_score';
    }
    return(
      <SMFormValidationMessage
        name="net_promoter_score"
        withIcon={true}
        errorText={errorText} />
    );
  }

  renderNPSForm() {
    return(
      <div className="form-box mb80">
        <span className="mr10">薦めない</span>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="1" id="form-radio01__01" name="net_promoter_score" checked={this.state.net_promoter_score == 1} />
        <label htmlFor="form-radio01__01" className="post-review__satisfaction-radio">1</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="2" id="form-radio01__02" name="net_promoter_score" checked={this.state.net_promoter_score == 2} />
        <label htmlFor="form-radio01__02" className="post-review__satisfaction-radio">2</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="3" id="form-radio01__03" name="net_promoter_score" checked={this.state.net_promoter_score == 3} />
        <label htmlFor="form-radio01__03" className="post-review__satisfaction-radio">3</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="4" id="form-radio01__04" name="net_promoter_score" checked={this.state.net_promoter_score == 4} />
        <label htmlFor="form-radio01__04" className="post-review__satisfaction-radio">4</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="5" id="form-radio01__05" name="net_promoter_score" checked={this.state.net_promoter_score == 5} />
        <label htmlFor="form-radio01__05" className="post-review__satisfaction-radio">5</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="6" id="form-radio01__06" name="net_promoter_score" checked={this.state.net_promoter_score == 6} />
        <label htmlFor="form-radio01__06" className="post-review__satisfaction-radio">6</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="7" id="form-radio01__07" name="net_promoter_score" checked={this.state.net_promoter_score == 7} />
        <label htmlFor="form-radio01__07" className="post-review__satisfaction-radio">7</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="8" id="form-radio01__08" name="net_promoter_score" checked={this.state.net_promoter_score == 8} />
        <label htmlFor="form-radio01__08" className="post-review__satisfaction-radio">8</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="9" id="form-radio01__09" name="net_promoter_score" checked={this.state.net_promoter_score == 9} />
        <label htmlFor="form-radio01__09" className="post-review__satisfaction-radio">9</label>
        <input onChange={this.toggleChangeNPSValue.bind(this)} type="radio" value="10" id="form-radio01__10" name="net_promoter_score" checked={this.state.net_promoter_score == 10} />
        <label htmlFor="form-radio01__10" className="post-review__satisfaction-radio">10</label>
        薦めたい
        {this.renderNPSError('score')}
      </div>
    );
  }

  toggleChangeRoomFeaturesValue(e) {
    const roomFeatures = this.state.room_features;
    const index = roomFeatures.indexOf(e.currentTarget.value);
    if (index == -1) {
      roomFeatures.push(e.currentTarget.value);
    } else {
      roomFeatures.splice(index, 1);
    }
    
    this.setState({
      room_features: roomFeatures
    });
  }

  renderRoomFeaturesForm() {
    const rows = [];
    const roomFeatureList = this.props.room_feature_list;
    const roomFeatures = this.state.room_features;
 
    roomFeatureList.forEach((element, index)=>{
      const id = "form-checkbox01__" + element.id;
      const checked = roomFeatures.indexOf(element.name) != -1;
      rows.push(
        <input key={id + "_input"} onChange={this.toggleChangeRoomFeaturesValue.bind(this)} checked={checked} type="checkbox" value={element.name} id={id} name="room_features[]" />
      );
      rows.push(
        <label key={id + "_label"} htmlFor={id} className="post-review__feature-checkbox">{element.name_text}</label>
      );
    });
   
    return(
      <div className="form-box mb80">
        {rows}
        {this.renderReputationError("base")}
      </div>
    );
  }

  subscribeRateEvent() {
    let $starContainer = $(this.refs.starContainer),
        $stars = $starContainer.find("i"),
        required = "fa fa-star post-review-star__star fa-2x";
   
    $stars.
      on("mouseenter", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return;
        this.renderStars($(e.currentTarget).data("score"));
      }).
      on("mouseleave", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return;
        this.renderStars(this.state.score);
      }).
      on("click", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return false;
        this.setState({score: $(e.currentTarget).data("score")});
        this.renderStars(this.state.score);
        return false;
      });
  }

  renderStars(max) {
    let $starContainer = $(this.refs.starContainer),
        $stars = $starContainer.find("i"),
        required = "fa fa-star post-review-star__star fa-2x";
    $stars.each(function(i){
      let c = required + ((max <= i) ? " is-default" : " is-checked");
      $(this).attr("class", c);
    });
  }

  didChangeDescriptionValue(e){
    this.setState({
      description: e.currentTarget.value,
    });
  }

  canSendForm() {
    const canSendForm = this.state.score &&
                      this.state.description &&
                      this.state.room_features.length > 0 &&
                      this.state.net_promoter_score;
 
    return (!!canSendForm);
  }

  renderSubmitButton(){
    let disabled = null;
    let buttonClass = null;
 
    if (this.canSendForm()) {
      disabled = false;
      buttonClass = "button-green ";
    } else {
      disabled = true;
      buttonClass = "";      
    }
    
    return(
      <div className="maincol-buttonarea dashboard-maincol__right-inner-100pc">
        <input disabled={disabled} className={buttonClass + "maincol-buttonarea__button"} type="submit" value="投稿する" />
      </div>
    );
  }

  renderReputationError(field) {
    let errorText = SMFormatHelper.errorText('Reputation', field, this.state.errors);
 
    if (field == 'base') {
      field = 'room_features';
    }
    return(
      <SMFormValidationMessage
        name={field}
        withIcon={true}
        errorText={errorText} />
    );
  }

  renderReviewForm() {
    return(
      <div className="form-box mb80">
        <p className="dashboard-content mb15">
          <span className="message-supplement">ゲストとホストの両者が記述したタイミングでサイトに公開されます。提出期限を過ぎた時点で片方しかレビューを書いていない場合は、片方のレビューのみが公開されます。</span>
        </p>
        <input disabled={false} name="score" value={this.state.score} type="hidden"></input>
        <textarea disabled={false} onChange={this.didChangeDescriptionValue.bind(this)} name="description" value={this.state.description} className="form-textarea post-review-form" placeholder={I18n.t("dashboard.text_000901")}></textarea>
        <div className="clearfix">
          <p ref="starContainer" className="post-review-star">
            <a href="#"><i data-score="1" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="2" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="3" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="4" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="5" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
          </p>
          <p className="message-supplement post-review-star__comment">{I18n.t("dashboard.label_000105")}</p>
        </div>
        {this.renderReputationError("description")}
        {this.renderReputationError("score")}
      </div>
    );
  }

  render() {
    const reservation = this.props.reservation;
    const user = reservation.user;
    const canBeReviewed = reservation.can_be_reviewed;
    const action = Routes.dashboard_reservation_reputation_path({user_id: user.id, reservation_id: reservation.uid});
    const patchTag = this.props.hasReputation ? 
      <div>
        <input type="hidden" name="_method" value="PATCH" />
        <input type="hidden" name="reputation_id" value={this.state.id} />
      </div> : null;
 
    if (canBeReviewed) {
      return (
        <div className="dashboard-container clearfix mb30">
          <div className="dashboard-maincol">
            <form onSubmit={this.trackPageEvent.bind(this)} ref='form' action={action} method="post">
              <input type="hidden" name="authenticity_token" value={this.props.authenticity_token} />
              {patchTag}
              <div className="dashboard-singlecol">
                <SMReservationHeaderView
                  isOwner={false}
                  reservation={reservation} />
 
                <h2 className="dashboard-section mb50">スペースについて</h2>
                <h3 className="dashboard-title mb10">
                  <span className="icon-form icon-form__required">必須</span>
                  このスペースへのレビューをお聞かせください
                </h3>
                {this.renderReviewForm()}
 
                <h3 className="dashboard-title mb15">
                  <span className="icon-form icon-form__required">必須</span>
                  このスペースの特長を教えてください
                </h3>
                <p className="dashboard-content mb15">
                  <span className="message-supplement">複数選択できます。この項目はサイトに公開されます。</span>
                </p>
                {this.renderRoomFeaturesForm()}
              
                <h2 className="dashboard-section mb50">スペースマーケットについて</h2>
                <h3 className="dashboard-title mb15">
                  <span className="icon-form icon-form__required">必須</span>
                  スペースマーケットを友人や同僚に薦めようと思いますか？
                </h3>
                <p className="dashboard-content mb15">
                  <span className="message-supplement">スペースマーケットを友人や同僚に薦めたいかを評価してください。数字が大きいほど薦めたい評価となります。<br />この項目はサイトに公開されません。</span>
                </p>
                {this.renderNPSForm()}
                
                <h3 className="dashboard-title mb15">
                  <span className="icon-form icon-form__optional">任意</span>
                  スペースマーケットへのご意見をお聞かせください
                </h3>
                <p className="dashboard-content mb15">
                  <span className="message-supplement">この項目はサイトに公開されません。</span>
                </p>
                {this.renderServiceDescriptionForm()}
                
              </div>
              {this.renderSubmitButton()}
            </form>
          </div>
        </div>
      );
    } else {
      return (
        <div className="dashboard-container clearfix mb30">
          <div className="dashboard-maincol">
            <form>
              <div className="dashboard-singlecol">
                <p className="ta-c mt30 mb50">このレビューは投稿期限を過ぎたか既に公開されています。</p>
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
 }
 export default SMUReputationView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUReputationView.jsx